namespace Areas.Vendor {
    "use strict";

    let recordExists:boolean;

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.vendorId; },
            "<a href= '/Vendor/ViewPrint/Index/{placeholder}' target=\"_blank\">View</a>");
    }

    export function goBack() {
        window.history.back();
    }

    export function gotoVendors() {
        var linkInfo = "/Vendor/List/Index";
        location.href = linkInfo;
    }

    export function gotoCreate() {
        const createVendorDialog = new Areas.Dialogs.CreateVendorDialog(() => { });
    }

    export function gotoEdit() {
        var dataGrid = $('#VendorGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Vendor/Profile/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function goToEditFromViewPrint() {
        const form = $("#VendorProfileForm").dxForm("instance");

        const newData: any = form.option("formData");
        var vendorID = newData.VendorId;

        if (vendorID != null) {
            var linkInfo = "/Vendor/Profile/Index/" + vendorID.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("No Vendor ID, Contact I.S.!", "warning", 2000);
        }
    }


    export function gotoView() {
        var dataGrid = $('#VendorGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Vendor/ViewPrint/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoViewFromTabs(a) {
        var buttonId = a.element[0].id;

        if (buttonId === "RangeOption") {
                    var dataGrid: any = $("#BidRangeTypeGrid").dxDataGrid("instance");
                    var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "Ownership") {
                    var dataGrid: any = $("#OwnershipGrid").dxDataGrid("instance");
                    var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "Insurance") {
            var dataGrid: any = $("#InsuranceGrid").dxDataGrid("instance");
            var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "License") {
            var dataGrid: any = $("#LicenseGrid").dxDataGrid("instance");
            var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "Experience") {
            var dataGrid: any = $("#ExperiencGrid").dxDataGrid("instance");
            var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "Specialty") {
            var dataGrid: any = $("#SpecialtyGrid").dxDataGrid("instance");
            var vendorId: any = dataGrid.option("VendorId");

        } else if (buttonId === "User") {
           var dataGrid: any = $("#UserGrid").dxDataGrid("instance");
           var vendorId: any = dataGrid.option("VendorId");
        }

  
        if (vendorId != null) {
            var linkInfo = "/Vendor/ViewPrint/Index/" + vendorId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoViewFromProfile(a, b) {
        const form = $("#VendorProfileForm").dxForm("instance");

        const newData: any = form.option("formData");
        var vendorId = newData.VendorId;

        if (vendorId != null) {
            var linkInfo = "/Vendor/ViewPrint/Index/" + vendorId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("No Vendor ID, Contact I.S.!", "warning", 2000);
        }
    }

    export function gotoVendorReview(e: any) {
        const grid = $("#VendorGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();
        var id = row[0].vendorId;

        if (row.length == 1) {
            $.get(`/Vendor/List/CheckContractVendorLinkExists/${id}`).then((data) => {
                if (data === true) {
                    const linkInfo = "/Reviewers/CapSTARLink/View/" + id;
                    location.href = linkInfo;
                }

                if (data === false) {
                    Areas.Vendor.createContractVendorLink(e);
                }
            });
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function createContractVendorLink(e: any) {
        const dataGrid: any = $("#VendorGrid").dxDataGrid("instance");
        const selectedRows: any = dataGrid.getSelectedRowsData();
        const dataId = selectedRows[0].vendorId;

        const parameters: any = { dataId : dataId };

        const createCapSTARVendorLinkDialog =
            new Areas.Dialogs.CreateContractVendorLinkDialog(dialogContractVendorLinkClosing, parameters);
    }

    function dialogContractVendorLinkClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const linkInfo = "/Reviewers/ContractLink/Edit/" + data.vendorId;
        location.href = linkInfo;

    }

}